var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _circle2, _circle3, _circle4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGutensliderIcon = function SvgGutensliderIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1-1h582v402H-1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 252.5,
    fill: "#3f007f",
    cy: 256.815,
    cx: 256.815
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d8d8d8",
    d: "M417.2 384.2H94.8c-.9 0-1.5-.7-1.5-1.5V129.4c0-.9.7-1.5 1.5-1.5h322.4c.9 0 1.5.7 1.5 1.5v253.2c.1.9-.6 1.6-1.5 1.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M104.3 163.3h303.5v209.8H104.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.3 163.3h303.5V193H104.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M301.4 186H128.2c-4.2 0-7.6-3.4-7.6-7.6 0-4.2 3.4-7.6 7.6-7.6h173.2c4.2 0 7.6 3.4 7.6 7.6 0 4.1-3.4 7.6-7.6 7.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6E9EE",
    d: "M192.1 232.2h127.8v10.3H192.1zM192.1 259.1h127.8v10.3H192.1zM192.1 285.9h127.8v10.3H192.1zM192.1 312.7h58.2V323h-58.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#c6c6c6",
    d: "M347.7 315.6c-1.5 0-3-.6-4.2-1.7-2.3-2.3-2.3-6.1 0-8.4l27.8-27.8-27.8-27.8c-2.3-2.3-2.3-6.1 0-8.4 2.3-2.3 6.1-2.3 8.4 0l32 32c1.1 1.1 1.7 2.6 1.7 4.2s-.6 3.1-1.7 4.2l-32 32c-1.1 1.1-2.7 1.7-4.2 1.7zM164.3 315.6c-1.5 0-3-.6-4.2-1.7l-32-32c-1.1-1.1-1.7-2.6-1.7-4.2s.6-3.1 1.7-4.2l32-32c2.3-2.3 6.1-2.3 8.4 0 2.3 2.3 2.3 6.1 0 8.4l-27.8 27.8 27.8 27.8c2.3 2.3 2.3 6.1 0 8.4-1.2 1.1-2.7 1.7-4.2 1.7z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cy: 146.29,
    cx: 395.822,
    strokeOpacity: "null",
    strokeWidth: "null",
    stroke: "null",
    fill: "#00bf00",
    r: 7.338
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cy: 146.29,
    cx: 375.44,
    strokeOpacity: "null",
    strokeWidth: "null",
    stroke: "null",
    fill: "#ffcf56",
    r: 7.338
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cy: 146.29,
    cx: 354.242,
    strokeOpacity: "null",
    strokeWidth: "null",
    stroke: "null",
    fill: "#ff5656",
    r: 7.338
  })));
};

export { SvgGutensliderIcon as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiaW1hZ2VzL2d1dGVuc2xpZGVyX2ljb24uc3ZnIjs=";